import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreOrganizationIntegration,
} from '../firestore/OrganizationIntegration/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class OrganizationIntegration extends ObservableModelWithDecorators<FirestoreOrganizationIntegration> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreOrganizationIntegration>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
